import React from "react";
import { Link } from "react-router-dom";
import "../css/about.scss";

function About() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="about-page" aria-labelledby="about-title">
      <div className="about-inner">
        <header className="about-intro">
          <p className="about-eyebrow">pmistpearl · Hong Kong</p>
          <h1 id="about-title">our story</h1>
          <p className="about-deck">
            Modern pearl jewellery selected for quiet, everyday elegance.
          </p>
        </header>

        <div className="about-story">
          <figure className="about-image-wrap">
            <img
              className="about-image"
              src="/editorial/about.png"
              alt="Freshwater pearls arranged beside jewellery sketches and findings"
            />
            <figcaption>Selected in Hong Kong for everyday and special occasions.</figcaption>
          </figure>

          <article className="about-copy">
            <p className="about-chapter">01 · Thoughtful communication</p>
            <h2>A quiet framework for your story.</h2>
            <p>
              pmistpearl brings together wearable pearl jewellery for ordinary days and
              meaningful occasions. Each piece is selected for balanced proportions,
              comfortable wear and the natural character of freshwater pearls.
            </p>
            <p>
              Our visual language pairs classic composition with practical details and an
              occasional touch of whimsy. The result is considered, useful, and personal
              enough to feel at home in the hand.
            </p>

            <div className="about-divider" aria-hidden="true" />

            <p className="about-chapter">02 · Where it began</p>
            <h2>A lasting appreciation for natural pearl character.</h2>
            <p>
              Based in Hong Kong, our small team works with established jewellery suppliers
              and inspects each style before it joins the collection. Natural variations in
              shape, tone and surface are part of every pearl's individual beauty.
            </p>

            <nav className="about-links" aria-label="Explore pmistpearl">
              <Link to="/shop" onClick={toTop}>
                Explore pearl goods <span aria-hidden="true">→</span>
              </Link>
              <Link to="/contact" onClick={toTop}>
                Start a conversation <span aria-hidden="true">→</span>
              </Link>
            </nav>
          </article>
        </div>
      </div>
    </main>
  );
}

export default About;
